import React from "react";
import {PageController} from "../../../../components/PageController";
import { useTranslation } from 'react-i18next';
import UserScale from "../UserScale";
import Gender from "../Gender";
import {CurrentBodyType} from "../CurrentBodyType/CurrentBodyType";
import {Height} from "../Height/Height";
import AgeRange from "../AgeRange";
import {ActivityLevel} from "../ActivityLevel";
import {ResultsTiming} from "../ResultsTiming";
import {HealthConcerns} from "../HealthConcerns";
import {TargetBodyType} from "../TargetBodyType";
import {CurrentWeight} from "../CurrentWeight";
import {TargetWeight} from "../TargetWeight";
import {Age} from "../Age";
import LastingResults from "../LastingResults";
import ProfileSummary from "../ProfileSummary";
import {AchieveGoal} from "../AchieveGoal/AchieveGoal";
import LoseWeightFaster from "../LoseWeightFaster";
import BetterFood from "../BetterFood";
import {FoodsOftenEat} from "../FoodsOftenEat";
import {FoodsDislikeEat} from "../FoodsDislikeEat";
import OtherBenefits from "../OtherBenefits";
import {FoodScan} from "../FoodScan";
import UserPower from "../UserPower";
import CreatingPlan from "../CreatingPlan";
import Email from "../Email";
import UserName from "../UserName";
import {WaterIntake} from "../WaterIntake";
import {MealTime} from "../MealTime";
import {LastMealTime} from "../LastMealTime";
import {MealCount} from "../MealCount";
import {FoodRestrictions} from "../FoodRestrictions";
import {DietaryPreference} from "../DietaryPreference";
import {CraveFood} from "../CraveFood";
import {KeepRecord} from "../KeepRecord";
import {KnowNutrients} from "../KnowNutrients";
import IllustratedOne from "../IllustratedOne";
import IllustratedTwo from "../IllustratedTwo";
import IllustratedThree from "../IllustratedThree";
import IllustratedFour from "../IllustratedFour";
import {NavigationEnum} from "../../../../enum/NavigationEnum";
import {CurrentBodyTypeHook} from "../CurrentBodyType/CurrentBodyTypeHook";
import {TargetBodyTypeHook} from "../TargetBodyType/TargetBodyTypeHook";
import {PayScreen} from "../PayScreen";
import {createQuestionnaireFormData, getQuestionnaireConfigById, QUESTIONNAIRE_IDS} from "../../../../domin/questionnaire/registry";

export const WeightLoss = () => {
    const { t, i18n } = useTranslation();
    const questionnaireConfig = getQuestionnaireConfigById(QUESTIONNAIRE_IDS.WEIGHT_LOSS);
    const formData = createQuestionnaireFormData(questionnaireConfig);
    return (<PageController
        formData={formData}
        pages={[
            {
                pageId: "ageRange",
                navigationStatus: NavigationEnum.SHOW_ICON,
                component: AgeRange
            },
            {
                pageId: "userScale",
                navigationStatus: NavigationEnum.SHOW_ICON,
                component: UserScale,
                displayBtn: true,
            },
            {
                pageId: "gender",
                navigationStatus: NavigationEnum.NORMAL,
                component: Gender,
            },
            {
                pageId: "currentBodyType",
                navigationStatus: NavigationEnum.NORMAL,
                component: CurrentBodyTypeHook,
            },
            {
                pageId: "targetBodyType",
                navigationStatus: NavigationEnum.NORMAL,
                component: TargetBodyTypeHook,
            },
            {
                pageId: "height",
                navigationStatus: NavigationEnum.NORMAL,
                component: Height,
                displayBtn: true,
                defaultAllow: false
            },
            {
                pageId: "currentWeight",
                navigationStatus: NavigationEnum.NORMAL,
                component: CurrentWeight,
                displayBtn: true,
                defaultAllow: false
            },
            {
                pageId: "targetWeight",
                navigationStatus: NavigationEnum.NORMAL,
                component: TargetWeight,
                displayBtn: true,
                defaultAllow: false
            },
            {
                pageId: "age",
                navigationStatus: NavigationEnum.NORMAL,
                component: Age,
                displayBtn: true,
                defaultAllow: false
            },
            {
                pageId: "lastingResults",
                navigationStatus: NavigationEnum.SHOW_ICON,
                component: LastingResults,
                displayBtn: true,
            },
            {
                pageId: "activityLevel",
                navigationStatus: NavigationEnum.NORMAL,
                component: ActivityLevel,
            },
            {
                pageId: "healthConcerns",
                navigationStatus: NavigationEnum.NORMAL,
                component: HealthConcerns,
                displayBtn: true,
                defaultAllow: false
            },
            {
                pageId: "profileSummary",
                navigationStatus: NavigationEnum.SHOW_ICON,
                component: ProfileSummary,
                displayBtn: true,
            },
            {
                pageId: "resultsTiming",
                navigationStatus: NavigationEnum.NORMAL,
                component: ResultsTiming,
            },
            {
                pageId: "achieveGoal",
                navigationStatus: NavigationEnum.NORMAL,
                component: AchieveGoal,
                displayBtn: true,
                defaultAllow: false
            },
            {
                pageId: "loseWeightFaster",
                navigationStatus: NavigationEnum.SHOW_ICON,
                component: LoseWeightFaster,
                displayBtn: true,
            },
            {
                pageId: "waterIntake",
                navigationStatus: NavigationEnum.NORMAL,
                component: WaterIntake,
            },
            {
                pageId: "mealTime",
                navigationStatus: NavigationEnum.NORMAL,
                component: MealTime,
            },
            {
                pageId: "lastMealTime",
                navigationStatus: NavigationEnum.NORMAL,
                component: LastMealTime,
            },
            {
                pageId: "mealCount",
                navigationStatus: NavigationEnum.NORMAL,
                component: MealCount,
            },
            {
                pageId: "betterFood",
                navigationStatus: NavigationEnum.SHOW_ICON,
                component: BetterFood,
                displayBtn: true
            },
            {
                pageId: "foodRestrictions",
                navigationStatus: NavigationEnum.NORMAL,
                component: FoodRestrictions,
                displayBtn: true,
                defaultAllow: false
            },
            {
                pageId: "foodsOftenEat",
                navigationStatus: NavigationEnum.NORMAL,
                component: FoodsOftenEat,
                displayBtn: true
            },
            {
                pageId: "foodsDislikeEat",
                navigationStatus: NavigationEnum.NORMAL,
                component: FoodsDislikeEat,
                displayBtn: true
            },
            {
                pageId: "dietaryPreference",
                navigationStatus: NavigationEnum.NORMAL,
                component: DietaryPreference
            },
            {
                pageId: "otherBenefits",
                navigationStatus: NavigationEnum.SHOW_ICON,
                component: OtherBenefits,
                displayBtn: true
            },
            {
                pageId: "craveFood",
                navigationStatus: NavigationEnum.NORMAL,
                component: CraveFood,
                displayBtn: true,
                defaultAllow: false
            },
            {
                pageId: "keepRecord",
                navigationStatus: NavigationEnum.NORMAL,
                component: KeepRecord,
            },
            {
                pageId: "knowNutrients",
                navigationStatus: NavigationEnum.NORMAL,
                component: KnowNutrients,
            },
            {
                pageId: "foodScan",
                navigationStatus: NavigationEnum.SHOW_ICON,
                component: FoodScan,
                displayBtn: true
            },
            {
                pageId: "illustratedOne",
                navigationStatus: NavigationEnum.NORMAL,
                component: IllustratedOne,
            },
            {
                pageId: "illustratedTwo",
                navigationStatus: NavigationEnum.NORMAL,
                component: IllustratedTwo,
            },
            {
                pageId: "illustratedThree",
                navigationStatus: NavigationEnum.NORMAL,
                component: IllustratedThree,
            },
            {
                pageId: "illustratedFour",
                navigationStatus: NavigationEnum.NORMAL,
                component: IllustratedFour,
            },
            {
                pageId: "userPower",
                navigationStatus: NavigationEnum.SHOW_ICON,
                component: UserPower,
                displayBtn: true,
            },
            {
                pageId: "creatingPlan",
                navigationStatus: NavigationEnum.NONE,
                component: CreatingPlan,
            },
            {
                pageId: "email",
                navigationStatus: NavigationEnum.NORMAL,
                component: Email,
                displayBtn: true,
                defaultAllow: false
            },
            {
                pageId: "userName",
                navigationStatus: NavigationEnum.NORMAL,
                component: UserName,
                displayBtn: true,
                defaultAllow: false
            },
            {
                pageId: "pay",
                navigationStatus: NavigationEnum.NONE,
                component: PayScreen,
            }
        ]}
        localStorageKey={questionnaireConfig.localStorageKey}
        mode={questionnaireConfig.mode}
    />)
};
